<template>
<!--底部按钮   不带底部导航-->
  <div id="bottom-button">
    <div id="bottomBox" :class="['bottom-wrapper', className]" :style="{marginBottom:65+tabHeight +'px'}">
      <div id="bottom-btn" class="bottom-btn" :class="{ active: state, inactive: !state}" @click="bottomClick">{{title}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: '',
    state: 0,
    className: ''
  },
  data () {
    return {
      tabHeight: 10
    }
  },
  methods: {
    bottomClick: function () {
      this.$emit('click', 0)
    },
    androidTabHeight: function (value) {
      // Toast('tabHeight===' + value)
      // 设置android 模态导航条
      if (this.utils.isIphone()) {
        if (this.utils.isIphoneX()) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = this.tabHeight + parseInt(value)
      }
    }
  },
  mounted () {
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || 
      parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
        console.log("按钮3进入:",window.zxzx.getNavigationBarHeight())
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
  }
}
</script>

<style scoped>
.bottom-wrapper {
  position: fixed;
  width: 100%;
  bottom: 0px;
  background-color: #ffffff;
  border-top: solid #eeeeee 1px;
  box-sizing: border-box;
  z-index: 1000;
}
/*.bottom-wrapper .inner {*/
/*  position: absolute;*/
/*}*/
.bottom-wrapper .bottom-btn {
  position: absolute;
  left: 15px;
  right: 15px;
  width: calc(100% - 30px);
  top: 10px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  font-size: 15px;
  color: #ffffff;
  border-radius: 3px;
}
.inactive {
  background-color: #fecdcd;
}
.active {
  background-color: #c41335;
}
</style>



// WEBPACK FOOTER //
// src/components/bottom-button3.vue